// extracted by mini-css-extract-plugin
export default {"overlay":"CommonModal_overlay__m5pn-","container":"CommonModal_container__7la1C"};